import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FacetListModule, ActiveFacetsModule, IconModule, ProductFacetNavigationModule, FacetModule, FacetListComponent, KeyboardFocusModule, AtMessageModule } from '@spartacus/storefront';
import { FacetListKbComponent } from './facet-list-kb/facet-list-kb.component';
import { FacetKbComponent } from './facet-kb/facet-kb.component';
import { FacetActiveKbComponent } from './facet-active-kb/facet-active-kb.component';
import { FacetNavigationComponent } from './facet-navigation/facet-navigation.component';
import { RouterModule } from '@angular/router';
import { SecureGuard } from 'src/app/services/Guards/secure.service';


@NgModule({
  declarations: [
    FacetListKbComponent,
    FacetKbComponent,
    FacetActiveKbComponent,
    FacetNavigationComponent,
  ],
  imports: [
    CommonModule,
    FacetListModule,
    I18nModule,
    ProductFacetNavigationModule,
    FacetListModule,
    FacetModule,
    ActiveFacetsModule,
    RouterModule,
    IconModule,
    KeyboardFocusModule,
    UrlModule,
    AtMessageModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductRefinementComponent: {
          component: FacetNavigationComponent,
          guards: [SecureGuard]
        }
      }
    } as CmsConfig)
  ], exports: [FacetNavigationComponent]
})
export class FacetNavigationModule { }
